import * as bootstrap from 'bootstrap';
import GLightbox from 'glightbox';

require('select2');

window.bootstrap = bootstrap;
window.GLightbox = GLightbox;

// $(".select2").select2({});

window.applySelect2ToGasStationSelector = function () {
    $('.select2#projectGasStationId')
        .select2({
            dropdownParent: $('#createProjectModal')
        })
        .on('select2:select', function (e) {
            if (e.params.data.id == '--- Choose station or create new ---' || e.params.data.id == 0) {
                $('#newGasStationFieldset').show();
            } else {
                $('#newGasStationFieldset').hide();
            }
        });
};

applySelect2ToGasStationSelector();
